import AlertIcon from "../../../../svgs/AlertIcon";
import { GroupTileStyles } from "./GroupTileStyles";
import { Button } from "@mui/material";
import CallIcon from "../../../../svgs/CallIcon";
import { useForceUpdateOnInterval } from "../../../../utils/customHooks/genericHooks";
import truncateTime from "../../../../utils/timeUtils";
import { SERVER_NAMES } from "components/Nav/Drawers/RightDrawer/FlightDebugger/SERVER_NAMES";
import { useIsDarkMode } from "store/atoms";
import { useFlightConfig } from "components/DataGetter/FlightConfig/useFlightConfig";

const CallStart = ({ callStartMs }) => {
  // update the now with recursive setTimeout
  const now = useForceUpdateOnInterval({ updateInterval: 5000 });

  const { displayedTime, displayedUnit } = truncateTime({
    durationMs: now - callStartMs,
  });
  return (
    <>
      <div className="group-call-icon">
        <CallIcon />
      </div>
      <div className="group-call-time">
        <span className="group-call-state-elapsed">{displayedTime}</span>
        <span className="group-call-state-elapsed-units">{displayedUnit}</span>
      </div>
    </>
  );
};

const GroupTileContent = ({
  isLargeTiles,
  tileWidth,
  callStart,
  showCountNotMetricOnGroupTile,
  isTilesPageFullDay,
  output,
  outputLabel,
  metricPercent,
  isIdleUntagged,
  shortName,
  isCustomerWhoUsesGroupTileDataDump = false,
}) => {
  const [isDarkMode] = useIsDarkMode();
  const [
    {
      general: { tileWidthMultiplier: tileWidthConfig },
    },
  ] = useFlightConfig();
  return (
    <GroupTileStyles
      data-component-name={"Group Tile"}
      $isLargeTiles={isLargeTiles}
      $tileWidth={tileWidth}
      $tileWidthConfig={tileWidthConfig}
      $isDarkMode={isDarkMode}
    >
      <Button>
        <div className="group-tile">
          <div
            className="group-name"
            data-server-names={[SERVER_NAMES.midgardProcessGroups]}
          >
            {shortName}
          </div>

          {callStart ? (
            <CallStart callStartMs={callStart * 1000} />
          ) : (
            !callStart &&
            // if there's a count on any sub-process (showCountNotMetricOnGroupTile)
            // show the count + label
            (showCountNotMetricOnGroupTile && !isTilesPageFullDay ? (
              <div
                className="group-output"
                data-server-names={[SERVER_NAMES.midgardDataDumpsGroupTiles]}
              >
                <div className="group-output-quantity">
                  {output || output === 0 ? output.toFixed(0) : "--"}
                </div>
                <div className="group-output-label">
                  {outputLabel ? outputLabel : ""}
                </div>
              </div>
            ) : (
              <div
                className="group-performance"
                data-server-names={[
                  isCustomerWhoUsesGroupTileDataDump
                    ? SERVER_NAMES.midgardDataDumpsGroupTiles
                    : SERVER_NAMES.askrAggregates,
                ]}
              >
                {metricPercent || metricPercent === 0
                  ? metricPercent.toFixed(0)
                  : "--"}
              </div>
            ))
          )}
          {isIdleUntagged && (
            <div className="group-alert-icon">
              <AlertIcon />
            </div>
          )}
        </div>
      </Button>
    </GroupTileStyles>
  );
};

export default GroupTileContent;
